import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withTranslation } from 'react-i18next';

import RadioButtonComp from '../../../common/RadioButtonComp';

import { radioButtonOpzioneContrattuale, radioButtonOpzioneContrattualeUL } from '../../../store/radioButtonStore';

import DatiPianoErogazioniPeriodiche from './DatiPianoErogazioniPeriodiche';
import DatiTakeProfit from './DatiTakeProfit';
import DatiLifeCycle from './DatiLifeCycle';
import DatiPianoSpostamentoAutomatico from './DatiPianoSpostamentoAutomatico';

import * as actions from './action/datiOpzioniContrattuali';
import * as actionType from './actionType/datiOpzioniContrattuali';
import { textTrim } from '../../../../utility/genericUtility';
import { DATI_PIANO_EROGAZIONI_PERIODICHE, DATI_TAKE_PROFIT, DATI_LIFE_CYCLE, DATI_NESSUNO,
	     PRODOTTO_TIPOLOGIA_MULTINVEST, PRODOTTO_TIPOLOGIA_UNIT_LINKED, 
	     PRODOTTO_ZURICH_MISTEP_DYNAMIC_INVEST_EXTRA_M118, PRODOTTO_ZURICH_MULTINVESTO_PRO_M122,
	     PROFILO_M122P03_ACTIVE_80 } from '../../../../utility/jsConstants';

const styles = theme => ({
	textErrorMessage: theme.textErrorMessage,
});

const mapStateToProps = state => {
  //console.log('#RTCFA DatiOpzioniContrattuali.mapStateToProps.state', state);
  return {
    datiOpzioniContrattuali: state.areaDatiOpzioniContrattualiReducer.caratteristicheContratto.datiOpzioniContrattuali,
    checkLifeCycleM122P03: state.areaDatiOpzioniContrattualiReducer.caratteristicheContratto.datiOpzioniContrattuali.checkLifeCycleM122P03,
    datiRipartizionePremio: state.areaDatiRipartizionePremioReducer.caratteristicheContratto.datiRipartizionePremio,
    prodotto: state.areaProdottoReducer.prodotto,
  };
};

const mapDispatchToProps = dispatch => {
  //console.log('#RTCFA DatiOpzioniContrattuali.mapDispatchToProps.dispatch', dispatch);
  return {
    updateDatiOpzioniContrattuali: (unDato, unActionType) => dispatch(actions.updateDatiOpzioniContrattuali(unDato, unActionType)),
  };
};

class DatiOpzioniContrattuali extends React.Component {

  constructor(props) {
    super(props);
    const datiOpzioniContrattuali = this.props.datiOpzioniContrattuali;
    this.state = {
      opzioneContrattuale: datiOpzioniContrattuali.opzioneContrattuale,
    };
  };

  handleChangeOpzioneContrattuale = event => {
    //    console.log('#RTCFA DatiOpzioniContrattuali opzioneContrattuale new value:' + event.target.value);
    const nuovaOpzioneContrattuale = textTrim(event.target.value, true);
    const vecchiaOpzioneContrattuale = textTrim(this.state.opzioneContrattuale, true);
    if (nuovaOpzioneContrattuale !== vecchiaOpzioneContrattuale) {
      
      // 2026-03-25 PFD: PRODOTTO MUTINVEST PRO M122 - START
      let checkLifeCycleM122P03 = 'OK';
      
      // Se scelta LifeCycle
      if (nuovaOpzioneContrattuale === DATI_LIFE_CYCLE) {
    	  if (this.props.prodotto.codice === PRODOTTO_ZURICH_MULTINVESTO_PRO_M122) {
			  // Per Prodotto M122 l'Opzione LifeCycle e' consentita solamente per il profilo 'Active 80 - M122P03'    		  
			  this.props.datiRipartizionePremio.lineaGuidata.forEach(function(item, index, array) {
				  if(textTrim(item.codiceLinea, true) !== PROFILO_M122P03_ACTIVE_80){
					  checkLifeCycleM122P03 = 'KO';					
				  }
			  });
    	  }
      }
      
      this.props.updateDatiOpzioniContrattuali(checkLifeCycleM122P03, actionType.CHECK_LIFE_CYCLE_M122P03);
      // 2026-03-25 PFD: PRODOTTO MUTINVEST PRO M122 - END      
      
      if (checkLifeCycleM122P03 === 'OK') {
	      this.props.updateDatiOpzioniContrattuali(nuovaOpzioneContrattuale, actionType.UPDATE_OPZIONE_CONTRATTUALE);
	      this.setState({
	        opzioneContrattuale: nuovaOpzioneContrattuale,
	      });
      }
    }
  };

  render() {
    const { classes, datiOpzioniContrattuali, prodotto } = this.props;
    const { t } = this.props; //hoc  
    const tipoProdotto = prodotto.tipo;
    
    return (
      <Grid container direction="row" justify="center" alignItems="flex-start">
        <Grid item xs={12}>        
        {/*20230313 PFD - MISTEP-IFA: Gestione PRODOTTO MISTEP M118*/}
      	{prodotto.codice === PRODOTTO_ZURICH_MISTEP_DYNAMIC_INVEST_EXTRA_M118 &&
      		<Grid item xs={12}>
      			<DatiPianoSpostamentoAutomatico id='datiSpostamentoAutomatico' onError={this.handleError} />
      		</Grid>
      	}
      	
      	{/*20230313 PFD - MISTEP-IFA: Gestione PRODOTTO MULTIINVEST TRDIZIONALE*/}
      	{prodotto.codice !== PRODOTTO_ZURICH_MISTEP_DYNAMIC_INVEST_EXTRA_M118 && <>
      		{tipoProdotto === PRODOTTO_TIPOLOGIA_MULTINVEST &&
      			<RadioButtonComp onChange={this.handleChangeOpzioneContrattuale} radioComp={radioButtonOpzioneContrattuale} classes={{divider: classes.divider}} 
                	selectedValue={datiOpzioniContrattuali.opzioneContrattuale} required={false} id='opzioneContrattuale' onError={this.handleError} />
            }
            {tipoProdotto === PRODOTTO_TIPOLOGIA_UNIT_LINKED &&
            	<RadioButtonComp onChange={this.handleChangeOpzioneContrattuale} radioComp={radioButtonOpzioneContrattualeUL} classes={{divider: classes.divider}} 
            	selectedValue={datiOpzioniContrattuali.opzioneContrattuale} required={false} id='opzioneContrattuale' onError={this.handleError} />      		
            }
            </>
        }
        </Grid>
        {datiOpzioniContrattuali.opzioneContrattuale === DATI_NESSUNO &&	
        <Grid item xs={12}></Grid>
        }
        {datiOpzioniContrattuali.opzioneContrattuale === DATI_PIANO_EROGAZIONI_PERIODICHE &&	
        <Grid item xs={12}>  
          <DatiPianoErogazioniPeriodiche id='datiPianoErogazioniPeriodiche' onError={this.handleError} />
        </Grid>
        }
        {datiOpzioniContrattuali.opzioneContrattuale === DATI_TAKE_PROFIT &&	
        <Grid item xs={12}>  
          <DatiTakeProfit id='datiTakeProfit' onError={this.handleError} />
        </Grid>
        }
        {datiOpzioniContrattuali.opzioneContrattuale === DATI_LIFE_CYCLE &&	
        <Grid item xs={12}>  
          <DatiLifeCycle id='datiLifeCycle' onError={this.handleError} />
        </Grid>
        }
        
        <Grid item xs={12}>
          <Grid container direction='row' justify='center' alignItems='center'>	
            <Grid item>
          	  {(this.props.checkLifeCycleM122P03 === 'KO') &&
          		<Typography className={classes.textErrorMessage}>{t('erroreCheckLifeCycleM122P03')}</Typography>
          	  }
          	</Grid>
          </Grid>
        </Grid>
        
      </Grid>
    );
  }
}

DatiOpzioniContrattuali.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withStyles(styles)(DatiOpzioniContrattuali)));
